<template>
  <div>
    <hs-breadcrumb :breadcrumb="breadcrumb"></hs-breadcrumb>
    <Card :bordered="false" :style="{marginBottom:'10px'}">
      <div class="hs-screen-row">
        <Select v-model="params.recoveryUserId" placeholder="回收员" clearable style="width:200px">
          <Option v-for="(item, index) in recoveryUserList" :value="item.value" :key="index">{{ item.label }}</Option>
        </Select>
      </div>
      <div class="hs-screen-row">
        <Select v-model="params.score" placeholder="评分" clearable style="width:100px">
          <Option v-for="(item, index) in scoreList" :value="item.value" :key="index">{{ item.label }}</Option>
        </Select>
      </div>
      <div class="hs-screen-row">
        <DatePicker @on-change="changeDate" v-model="dateInit" type="daterange" :editable="false"
                    separator=" ~ " split-panels transfer
                    placeholder="创建时间" style="width: 200px"></DatePicker>
      </div>
      <div class="hs-screen-row">
        <Button type="primary" @click="findList">查询</Button>
      </div>
      <div class="hs-screen-row">
        <Button @click="resetScreen">重置</Button>
      </div>
    </Card>

    <Tabs type="card" @on-click="tabsClick">
      <TabPane label="用户评价" name="1"></TabPane>
      <TabPane label="回收员评价" name="2"></TabPane>
    </Tabs>

    <Card :bordered="false" :style="{marginBottom:'10px'}">
      <!--标题-->
      <div slot="title">
        <div class="hs-screen-box">
          <div>评价列表</div>
          <div>
            <ButtonGroup>
              <Button @click="findList">
                <Icon type="md-refresh" size="15"/>
              </Button>
            </ButtonGroup>
          </div>
        </div>
      </div>

      <!--表格数据-->
      <Table :columns="columns" :data="data" size="small" :stripe="true" :loading="isTableLoading"
             @on-select="selectTable" @on-select-cancel="selectCancelTable" @on-select-all="selectAllTable"
             @on-select-all-cancel="selectAllCancelTable">

        <template slot-scope="{ row, index }" slot="score">
          <Rate v-model="row.score" disabled/>
<!--          <span v-if="row.totalAmount">{{row.totalAmount}}</span>-->
<!--          <span v-else>-</span>-->
        </template>

        <template slot-scope="{ row }" slot="action">
          <Button type="success" size="small" style="margin-right: 5px" @click="showOrderOpe(row)">查看
          </Button>
        </template>
      </Table>
      <!--分页-->
      <div class="hs-page">
        <Page :total="total" show-sizer show-total transfer @on-change="changePage"
              @on-page-size-change="changePageSize"/>
      </div>
    </Card>

    <!--显示模态框-->
    <order-ope ref="orderOpe"></order-ope>
  </div>
</template>

<script>
import hsBreadcrumb from '@/components/hs-breadcrumb';
import orderOpe from '../order/components/order-ope';

export default {
  name: "admin",
  data() {
    return {
      admin: JSON.parse(sessionStorage.getItem('J-ADMIN')),
      total: 0,
      dateInit: '',
      isTableLoading: false,
      // 选中数据
      selectData: [],
      headers: {
        token: JSON.parse(sessionStorage.getItem('J-TOKEN')).token
      },
      // 参数
      params: {
        page: 1,
        rows: 10,
        type: 1,
        startTime: '',
        endTime: '',
        score: ''
      },
      // 表格列
      columns: [
        {
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: '订单ID',
          minWidth: 90,
          key: 'recoveryOrderId',
          ellipsis: true
        },
        {
          title: '用户名',
          minWidth: 180,
          key: 'userRealName'
        },
        {
          title: '评价内容',
          minWidth: 400,
          key: 'content'
        },
        {
          title: '评价打分',
          minWidth: 100,
          slot: 'score'
        },
        {
          title: '回收员',
          key: 'realName',
          width: 150
        },
        {
          title: '评价时间',
          key: 'createTime',
          width: 150
        },
        {
          title: '下单时间',
          key: 'orderCreateTime',
          width: 150
        },
        {
          title: '操作',
          slot: 'action',
          width: 145,
          align: 'center',
          fixed: 'right'
        }
      ],
      // 表格数据
      data: [],
      failOrderData: [],
      // 面包屑
      breadcrumb: [
        {name: '首页', url: '', icon: 'ios-home-outline', size: 18},
        {name: '订单评价管理', url: '', icon: '', size: 0},
        {name: '评价列表', url: '', icon: '', size: 0}
      ],
      recoveryUserList: [],
      tenantList: [],
      scoreList: [{'label': '一分', 'value': 1},
                  {'label': '二分', 'value': 2},
                  {'label': '三分', 'value': 3},
                  {'label': '四分', 'value': 4},
                  {'label': '五分', 'value': 5}],
    }
  },
  created() {
    // 订单-列表查询
    this.findRecoveryUserList()
    this.findList();
  },
  methods: {
    // 订单-列表查询
    findList() {
      this.isTableLoading = true;
      this.axios.post('/recoveryOrderEvaluate/findList', this.params).then(res => {
        this.isTableLoading = false;
        if (res.status == 200) {
          this.total = res.data.total;
          this.data = res.data.rows;
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询订单列表接口报错',
            duration: 0
          });
        }
      })
    },
    // 显示操作模态框
    showOrderOpe(row) {
      this.$refs.orderOpe.show(row);
    },
    tabsClick(name) {
      this.params.type = name
      this.findList()
    },
    // 日期条件赋值
    changeDate(e) {
      this.params.startTime = e[0];
      this.params.endTime = e[1];
    },
    // 重置筛选条件
    resetScreen() {
      this.params.recoveryUserId = '';
      this.params.startTime = '';
      this.params.endTime = '';
      this.dateInit = '';
      this.params.score = ''
    },
    // 改变页数
    changePage(e) {
      this.params.page = e;
      this.findList();
    },
    // 改变页容量
    changePageSize(e) {
      this.params.rows = e;
      this.findList();
    },
    // 在多选模式下有效，选中某一项时触发
    selectTable(selection, row) {
      this.selectData = selection;
    },
    // 在多选模式下有效，取消选中某一项时触发
    selectCancelTable(selection, row) {
      this.selectData = selection;
    },
    // 在多选模式下有效，点击全选时触发
    selectAllTable(selection) {
      this.selectData = selection;
    },
    // 在多选模式下有效，点击取消全选时触发
    selectAllCancelTable(selection) {
      this.selectData = selection;
    },
    // 回收员-列表查询
    findRecoveryUserList() {
      let params = {
        page: 1,
        rows: 20,
        isDisable: 0,
      }
      this.axios.post('/recoveryUser/findList', params).then(res => {
        if (res.status == 200) {
          if (res.data.rows) {
            this.recoveryUserList = []
            res.data.rows.forEach(v => {
              let object = {
                value: v.recoveryUserId,
                label: v.realName
              }
              this.recoveryUserList.push(object)
            })
          }
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询回收员列表接口报错',
            duration: 0
          });
        }
      })
    },
  },
  components: {
    hsBreadcrumb,
    orderOpe
  }
}
</script>